import isEmpty from "lodash/isEmpty";
import { useMemo } from "react";
import { LocaleCode, languages } from "shared/types/languages";
import { StaticTranslationsTableData } from "../types";

type HookProps = {
  initialList: StaticTranslationsTableData[];
  searchValue: string;
  filterByArea: string[];
  filterByContentItem: string[];
};

const useFilteredData = ({
  initialList,
  searchValue,
  filterByContentItem,
  filterByArea,
}: HookProps): StaticTranslationsTableData[] => {
  const languagesLocaleKeys = useMemo(
    () => languages.map((lang) => lang.id),
    [],
  );

  return useMemo(() => {
    if (isEmpty(initialList)) return [];

    const filteredDataBySearch = initialList.filter((el) =>
      languagesLocaleKeys.some((key: LocaleCode) =>
        String(el[key] || "")
          .toLowerCase()
          .includes(searchValue.toLowerCase()),
      ),
    );

    return filteredDataBySearch.filter((el) => {
      const matchesArea =
        isEmpty(filterByArea) ||
        (el.area && filterByArea.includes(el.area.toLowerCase()));

      const matchesContentItem =
        isEmpty(filterByContentItem) ||
        (el.contentItem &&
          filterByContentItem.includes(el.contentItem.toLowerCase()));

      return matchesArea && matchesContentItem;
    });
  }, [
    initialList,
    searchValue,
    filterByArea,
    filterByContentItem,
    languagesLocaleKeys,
  ]);
};

export default useFilteredData;
